import { FC } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { footerHeight } from "./hardCodeData";
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

// TikTok icon component
const TikTokIcon = () => (
  <Box
    component="span"
    sx={{
      fontSize: { xs: "16px", sm: "24px" },
      fontWeight: "bold",
      fontFamily: "Arial, sans-serif",
      color: "inherit",
    }}
  >
    TikTok
  </Box>
);

const Footer: FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        minHeight: footerHeight,
        background: "#252728",
        color: "#fff",
        fontSize: { xs: "3.2vw", sm: "16px" },
        px: { xs: 2, md: 4 },
        py: { xs: 2, md: 1 },
        gap: { xs: 2, md: 0 },
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      {/* Copyright */}
      <Typography
        sx={{
          fontSize: { xs: "3.2vw", sm: "16px" },
          textAlign: { xs: "center", md: "left" },
        }}
      >
        ©️ BYD Company Ltd. {t('common:all_rights_reserved')}
      </Typography>

      {/* Social Media and Phone */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: { xs: 1, sm: 2 },
          flexWrap: "wrap",
          justifyContent: "center",
          maxWidth: { xs: "100%", md: "auto" },
          overflow: "hidden",
        }}
      >
        {/* Phone */}
        <IconButton
          component="a"
          href="tel:+37379200221"
          sx={{
            color: "#fff",
            fontSize: { xs: "4vw", sm: "20px" },
            minWidth: { xs: "40px", sm: "48px" },
            height: { xs: "40px", sm: "48px" },
            "&:hover": {
              color: "#4CAF50",
            },
          }}
        >
          <LocalPhoneIcon sx={{ fontSize: { xs: "20px", sm: "24px" } }} />
        </IconButton>

        {/* Facebook */}
        <IconButton
          component="a"
          href="https://www.facebook.com/profile.php?id=61573449827242"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: "#fff",
            fontSize: { xs: "4vw", sm: "20px" },
            minWidth: { xs: "40px", sm: "48px" },
            height: { xs: "40px", sm: "48px" },
            "&:hover": {
              color: "#1877F2",
            },
          }}
        >
          <FacebookIcon sx={{ fontSize: { xs: "20px", sm: "24px" } }} />
        </IconButton>

        {/* Instagram */}
        <IconButton
          component="a"
          href="https://www.instagram.com/byd_cars_service/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: "#fff",
            fontSize: { xs: "4vw", sm: "20px" },
            minWidth: { xs: "40px", sm: "48px" },
            height: { xs: "40px", sm: "48px" },
            "&:hover": {
              color: "#E4405F",
            },
          }}
        >
          <InstagramIcon sx={{ fontSize: { xs: "20px", sm: "24px" } }} />
        </IconButton>

        {/* TikTok */}
        <IconButton
          component="a"
          href="https://www.tiktok.com/@byd.cars.service"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: "#fff",
            fontSize: { xs: "4vw", sm: "20px" },
            minWidth: { xs: "40px", sm: "48px" },
            height: { xs: "40px", sm: "48px" },
            "&:hover": {
              color: "#000000",
            },
          }}
        >
          <TikTokIcon />
        </IconButton>

        {/* Phone Number */}
        <Typography
          sx={{
            fontSize: { xs: "3.5vw", sm: "16px" },
            fontWeight: 600,
            color: "#fff",
            ml: { xs: 1, sm: 2 },
          }}
        >
          +373 79 200 221
        </Typography>

        {/* Address */}
        <Typography
          sx={{
            fontSize: { xs: "3vw", sm: "14px" },
            fontWeight: 400,
            color: "#ccc",
            ml: { xs: 1, sm: 2 },
          }}
        >
          {t("forms:str")} Uzinelor 8/1A
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
